module.exports = __webpack_public_path__ + "static/lifetimePhoneDocuments-177ae8c9fa70bee0ce331c8396ab7699.jpg";